import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
const ArticleSmall = dynamic(() => import('../article/articleSmall'))

function TrendingNewsContent({ data }) {
  return (
    <>
      {data?.map((news, index) => {
        return (
          <ArticleSmall data={news} key={news._id} hideBadge/>
        )
      })}
    </>
  )
}
TrendingNewsContent.propTypes = {
  data: PropTypes.array
}

export default TrendingNewsContent
